export default class QueryParamsSubtractor {
  public static fromObjectToString(obj: any): any {
    if (!obj || !(Object.keys(obj).length)) return '';
    const values = Object.values(obj);
    const keys = Object.keys(obj);
    const array: any[] = [];
    keys.forEach((prop: any, index: number) => array.push(`${prop}=${values[index]}`));
    const string = array.join('&');
    return `?${string}`;
  }
}
